/* El Laguito Concierge — reliability add-on (2026-10-27, Zein: "it went to the [hand-off form] directly instead of answering")
 * Loaded by sections/elc-concierge.liquid just BEFORE elc-concierge.js. It changes nothing in the widget itself; it only
 * steps in on two of the widget's own network calls:
 *   1. Training file: this theme reads elc-concierge-config-v2.json (matching lighter/pen guide, Boveda prices refreshed)
 *      instead of elc-concierge-config.json, so the live theme is untouched until this theme is published.
 *      (2026-11-03: elc-concierge.js on this theme now reads elc-concierge-config-floris.json directly; that request gets a
 *      10-minute version stamp so an updated training file reaches customers within 10 minutes — the CDN otherwise keeps
 *      the un-versioned address for a year.)
 *   2. AI retry: the AI service sometimes fails one attempt (an "err" event or HTTP error ~10-13 s in), and the widget then
 *      jumped straight to the hand-off form ("AI unavailable"). Now a failed attempt is retried quietly — up to 3 attempts
 *      in all, within 40 s — before the widget ever sees the failure. Once the answer starts streaming, it streams as before.
 *      The widget's own 45 s time-out still applies to the whole exchange.
 *   3. (2026-10-28) Humidor Calculator card limited to electric humidors / Raching — see the block at the end.
 * To retire this add-on: fold these changes into elc-concierge.js and remove the <script> line from the section.
 */
(function () {
  if (window.__elcCcFix || !window.fetch) return;
  window.__elcCcFix = true;

  var CFG_OLD = '/files/elc-concierge-config.json';
  var CFG_NEW = '/files/elc-concierge-config-v2.json';
  var CFG_FLORIS = '/files/elc-concierge-config-floris.json';
  var CHAT_RE = /^https:\/\/elg-concierge\.ellaguitocigars\.workers\.dev\/chat(?:[?#]|$)/;
  var MAX_ATTEMPTS = 3, MAX_MS = 40000;
  var nativeFetch = window.fetch.bind(window);

  window.fetch = function (input, init) {
    if (typeof input === 'string') {
      if (input.indexOf(CFG_OLD) > -1) return nativeFetch(input.replace(CFG_OLD, CFG_NEW), init);
      if (input.indexOf(CFG_FLORIS) > -1 && input.indexOf('?') === -1) return nativeFetch(input + '?v=' + Math.floor(Date.now() / 600000), init);
      if (CHAT_RE.test(input) && init && String(init.method || '').toUpperCase() === 'POST') return chatWithRetry(input, init);
    }
    return nativeFetch(input, init);
  };

  function chatWithRetry(url, init) {
    var started = Date.now(), attempts = 0, signal = init.signal;
    var aborted = function (e) { return (signal && signal.aborted) || (e && e.name === 'AbortError'); };
    var canRetry = function () { return attempts < MAX_ATTEMPTS && (Date.now() - started) < MAX_MS && !(signal && signal.aborted); };
    var attempt = function () { attempts += 1; return nativeFetch(url, init); };
    var isStream = function (r) { return r.ok && r.body && r.body.getReader && (r.headers.get('Content-Type') || '').indexOf('text/event-stream') > -1; };

    /* first attempt(s): retry HTTP errors and network failures before handing anything to the widget */
    var open = function () {
      return attempt().then(function (r) {
        if (!r.ok && canRetry()) return open();
        if (!isStream(r) || !window.ReadableStream || !window.TextDecoder) return r;
        return wrap(r);
      }, function (e) {
        if (!aborted(e) && canRetry()) return open();
        throw e;
      });
    };

    /* Pass the stream through untouched once real answer text ("d") or the final "done" event has arrived. Until then,
       hold it back: an "err" event, or an end without an answer, starts a fresh attempt instead of reaching the widget. */
    var wrap = function (first) {
      var reader = first.body.getReader(), dec = new TextDecoder(), seen = '', held = [], live = false;
      /* resolves true when a fresh answer stream is ready to read, false when it has given up (stream errored) */
      var restart = function (ctrl) {
        try { reader.cancel(); } catch (e) {}
        return attempt().then(function (r) {
          if (isStream(r)) { reader = r.body.getReader(); dec = new TextDecoder(); seen = ''; held = []; return true; }
          if (canRetry()) return restart(ctrl);
          ctrl.error(new Error('worker')); return false;
        }, function (e) {
          if (!aborted(e) && canRetry()) return restart(ctrl);
          ctrl.error(e); return false;
        });
      };
      var release = function (ctrl) { held.forEach(function (c) { ctrl.enqueue(c); }); held = []; };
      var body = new ReadableStream({
        /* each pull keeps reading until it has handed the widget something, closed or failed — the browser does not
           pull again on its own after a pull that delivered nothing (that stalled the chat after two failed attempts) */
        pull: function (ctrl) {
          var failed = false;
          var step = function () {
            return reader.read().then(function (st) {
              if (st.done) {
                if (!live && canRetry()) return restart(ctrl).then(next);
                release(ctrl); ctrl.close(); return;
              }
              if (live) { ctrl.enqueue(st.value); return; }
              held.push(st.value);
              seen += dec.decode(st.value, { stream: true });
              if (/"t"\s*:\s*"(?:d|done)"/.test(seen)) { live = true; release(ctrl); return; }
              if (/"t"\s*:\s*"err"/.test(seen)) {
                if (canRetry()) return restart(ctrl).then(next);
                release(ctrl); return;          /* out of attempts: let the widget see the error, as before */
              }
              return step();                    /* only the "start" event so far: keep reading */
            }, function (e) {
              if (!live && !aborted(e) && canRetry()) return restart(ctrl).then(next);
              failed = true; ctrl.error(e);
            });
          };
          var next = function (ready) { return (ready && !failed) ? step() : undefined; };
          return step();
        },
        cancel: function () { try { reader.cancel(); } catch (e) {} }
      });
      return new Response(body, { status: first.status, statusText: first.statusText, headers: first.headers });
    };

    return open();
  }
})();

/* 2026-10-28 (Zein): the Humidor Calculator card is for ELECTRIC humidors (Raching) only — never for Boveda packs,
 * starter kits, seasoning or desktop (non-electric) humidors. The widget used to add the card under ANY reply that
 * asked "how many cigars". Now it is added only when the most recent message that names a humidor type is about an
 * electric humidor / Raching; anything about packs, starter kits, seasoning or desktop humidors suppresses it. */
(function () {
  if (!window.customElements) return;
  var ELECTRIC = /\b(electric|electronic|raching|climate cabinet|cabinet|cooled|cooling)\b|électrique|électronique|armoire|cave à cigares/i;
  var NON_ELECTRIC = /boveda|\bpacks?\b|sachets?|starter kit|kit de démarrage|seasoning|season it|seasoned|assaisonn|\b(84|69|65|72|75) ?%|desktop|de bureau|wood(en)? humidor|cedar humidor|non[- ]electric|jemar|litolite|\bholders?\b|tupperdor|humidity pack/i;
  customElements.whenDefined('elc-concierge').then(function () {
    var C = customElements.get('elc-concierge');
    if (!C || !C.prototype.asksCount || C.prototype.__elcCalcFix) return;
    var orig = C.prototype.asksCount;
    C.prototype.__elcCalcFix = true;
    C.prototype.asksCount = function (text) {
      if (!orig.call(this, text)) return false;
      var texts = [String(text || '')], box = this.querySelector('[data-cc-msgs]');
      if (box) {
        var els = box.querySelectorAll('.elc-cc__msg');
        for (var i = els.length - 1; i >= 0 && texts.length < 7; i--) {
          var c = els[i].cloneNode(true);
          c.querySelectorAll('.elc-cc__calc,.elc-cc__confirm,.elc-cc__cfgbtns').forEach(function (n) { n.remove(); });
          var s = (c.textContent || '').trim();
          if (s) texts.push(s);
        }
      }
      for (var j = 0; j < texts.length; j++) {
        var non = NON_ELECTRIC.test(texts[j]), ele = ELECTRIC.test(texts[j]);
        if (non) return false;          /* packs / starter kits / seasoning / desktop — no calculator */
        if (ele) return true;           /* electric humidor / Raching — calculator helps */
      }
      return false;                     /* humidor type never named — no calculator */
    };
  });
})();
